import React from 'react';

import clsx from 'clsx';

import List from 'components/List';

import styles from './PasswordRequirements.module.scss';

interface Requirement {
  message: string;
  isValid: (password: string) => boolean;
}

export interface PasswordRequirementsProps {
  items: Requirement[];
  password: string;
  error?: string;
}

const PasswordRequirements = ({ items, password, error }: PasswordRequirementsProps) => {
  const requirements = items.map((item) => {
    return {
      message: item.message,
      messageClassName: clsx(styles.default, {
        [styles.requirementLabelSuccess]: item.isValid(password),
        [styles.requirementLabelError]: !item.isValid(password) && error,
      }),
      listItemClassName: clsx(styles.default, {
        [styles.requirementSuccess]: item.isValid(password),
        [styles.requirementError]: !item.isValid(password) && error,
      }),
    };
  });

  return <List items={requirements} />;
};

export default PasswordRequirements;
